/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-south-1",
    "aws_cloud_logic_custom": [
        {
            "name": "geoDemo",
            "endpoint": "https://gx8kt30bui.execute-api.eu-south-1.amazonaws.com/dev",
            "region": "eu-south-1"
        }
    ],
    "aws_appsync_graphqlEndpoint": "https://hl5wpk5lcndrjjcc56yka46ymy.appsync-api.eu-south-1.amazonaws.com/graphql",
    "aws_appsync_region": "eu-south-1",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_cognito_identity_pool_id": "eu-south-1:c2d14da4-372b-406d-99e4-3cd107e6d93f",
    "aws_cognito_region": "eu-south-1",
    "aws_user_pools_id": "eu-south-1_X5n9AJoiF",
    "aws_user_pools_web_client_id": "4v99nfhdr0pqh33aut3u3qqevt",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ]
};


export default awsmobile;
